import React from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Button} from "@chakra-ui/react";

type Prop = {
  error: {
    message: string
  },
  resetErrorBoundary: () => void
}

export function ErrorFallback({ error, resetErrorBoundary }: Prop) {
  return (
    <Flex role="alert" w={"100%"} h={"100vh"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
      <Text textTransform={"capitalize"} fontWeight={"semibold"} fontSize={"lg"}>Something went wrong:</Text>
      <br />
      <Text p={12}>{error.message}</Text>
      <br />
      <Button onClick={resetErrorBoundary} bgColor={"red.300"}>Try again</Button>
    </Flex>
  )
}